import {Component, EventEmitter, Input, Output, SimpleChange} from "@angular/core";
import {TextOperatorType} from "../../../../../../models/text-operator";
import {BaseFieldDeterminantComponent} from "./base-field-determinant.component";

@Component({
  selector: "text-determinant",
  templateUrl: "./text-determinant.component.html",
  styles: [],
})
export class TextDeterminantComponent extends BaseFieldDeterminantComponent {

  public operators: string[];
  @Input() public operator: TextOperatorType;
  @Input() public isTargetComponent: boolean;
  @Input() public textValue: string;
  @Input() public fields: any [] = [];
  @Input() public sourceFormFieldKey: string;
  @Input() public selectedField: any;
  @Input() public multiple: boolean = false;

  @Output() public textValueResponse = new EventEmitter();
  @Output() public operatorResponse = new EventEmitter();

  public ngOnInit() {
    this.operators = Object.keys(TextOperatorType);
    super.ngOnInit();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.operator && changes.operator.currentValue) {
      this.operator = changes.operator.currentValue;
    }
    if (changes.textValue && changes.textValue.currentValue) {
      this.textValue = changes.textValue.currentValue;
    }
    if (changes.fields && changes.fields.currentValue) {
      this.fields = this.fields.filter((field) => (field.type === "textfield" || field.type === "email" || field.type === "textarea"));
    }
    super.ngOnChanges(changes);
  }

  public textValueChanged(newValue: string) {
    this.textValueResponse.emit({textValue: newValue});
  }

  public operatorValueChanged() {
    this.operatorResponse.emit(this.operator);
  }

  public onTargetFormFieldKeyChange(event): void {
    this.sourceFormFieldKey = event;
    this.textValueResponse.emit({sourceFormFieldKey: this.sourceFormFieldKey});
  }

  public isStatusField(): boolean {
    return this.selectedField && this.selectedField.endsWith("selection");
  }

  public valueIsNullOrEmpty(): boolean {
    return !this.textValue || this.textValue === "";
  }
}
